import { Component } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CollegeConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-college-view',
  templateUrl: './college-view.component.html',
  styleUrls: ['./college-view.component.scss']
})
export class CollegeViewComponent {
  CollageForm: FormGroup = this.formBuilder.group({});
  imageURL:any;
  collegeId:number =0;
  CommonConstant:any=[];
  CollegeConstant:any=[];
  collegeBatchList:any=[];
  flag:boolean=false;
  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner:NgxSpinnerService
  ) { }

  ngOnInit(): void { 
    this.spinner.show();
    this.CommonConstant =CommonConstant;
    this.CollegeConstant = CollegeConstant;
    this.getCollageDetail(this.collegeId);
  }

  getCollageDetail(CollageId: number) { 
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeById.replace("{id}", CollageId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => { 
        this.collegeBatchList = data.data;
        if (data.data) {
          this.imageURL = data.data.collegeLogo ? data.data.collegeLogo : '';
        }
        this.spinner.hide()
        this.flag = true;
      },
      error: (err) => {
        console.log('getCollageDetail-Error', err);
      }
    });
  }
}